// extracted by mini-css-extract-plugin
export default {"container":"LFRKo9","listDividerColor":"Lgwamt","cardBorderColor":"o1s24v","listHoveredBorderColor":"jVBq6Q"};